<template>
  <v-card>
    <v-card-title class="primary white--text">
      <span class="headline"> {{ $t('editVersion') }} </span>
    </v-card-title>
    <v-card-text class="pt-6">
      <DatePicker v-if="initialized"
        dense
        :dateLabel="$t('effective')"
        :startDate="initEffectiveDate"
        :min="minDate"
        @date-picked="onDateChosen"/>
      <v-alert
        v-if="!isValid"
        border="left"
        color="error"
        dense
        text>
        {{ validationMessage }}
      </v-alert>
    </v-card-text>
    <v-card-actions class="pb-4 px-0 mt-4">
      <v-row justify="space-between">
        <v-col cols="auto"> <v-btn text outlined color="secondary" @click="editCanceled">{{ $t('cancel') }}</v-btn> </v-col>
        <v-col cols="auto"> <v-btn color="primary" :disabled="!isValid" @click="editConfirmed">{{ $t('confirm') }}</v-btn> </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/DateFormatter.js'
import { getActiveRateSheetVersion } from './RateSheetDefinitions'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

export default {
  name: 'RateSheetDefinitionVersionEditor',

  components: {
    DatePicker: () => import('@/components/helper/DatePicker.vue')
  },

  props: {
    versions: {
      type: Array,
      required: false,
      default: undefined
    },
    propVersion: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    initialized: false,
    version: null,
    initEffectiveDate: null
  }),

  async mounted () {
    this.intialize()
  },

  computed: {
    ...mapGetters('rate-sheet-definition', ['accountRateSheetDefinitions']),

    otherVersions () {
      return (this.versions || []).filter(v => v !== this.propVersion)
    },

    activeVersion () {
      return getActiveRateSheetVersion(cloneDeep(this.otherVersions)) || null
    },

    minDate () {
      return this.activeVersion
        ? moment(this.activeVersion.effectiveDate).add(1, 'day').format('YYYY-MM-DD')
        : undefined
    },

    validationMessage () {
      const picked = moment(this.version?.effectiveDate)
      if (this.activeVersion && picked.isSameOrBefore(moment(this.activeVersion.effectiveDate), 'day')) {
        return this.$t('mustBeAfterActiveVersion')
      }
      if (this.otherVersions.some(v => picked.isSame(moment(v.effectiveDate), 'day'))) {
        return this.$t('mustNotMatchExistingVersionDate')
      }
      return ''
    },

    isValid () {
      return !this.validationMessage
    }
  },

  methods: {
    formatDate,

    intialize () {
      this.version = cloneDeep(this.propVersion)
      this.initEffectiveDate = this.version.effectiveDate
      this.initialized = true
    },

    onDateChosen (date) {
      this.version.effectiveDate = date
    },

    editCanceled () {
      this.$emit('edit-canceled')
    },

    editConfirmed () {
      this.$emit('edit-confirmed', this.version)
    }
  }
}
</script>
